'use strict';

import React, { Component } from 'react'

const app = window.app;

export default class FrontOffice extends Component
{
	constructor (props)
	{
		super(props);

		app.router_history = this.props.history;
	}

	documentClick ()
	{
		app.emit('documentClick');
	}

	render ()
	{
		const component = this, props = this.props;

		let class_name = 'page-wrapper front-page';

		if (props['public-front'] === true)
		{
			class_name += ' public-front';
		}

		const output =
		(
			<div className={ class_name } onClick={ component.documentClick }>

				<div className="page u-center">

					<div className="page-body u-no-padding u-scroll-y">

						{ props.children }

					</div>

				</div>

			</div>
		);

		return output;
	}
}
